module.exports = __webpack_public_path__ + "img/fluorescence@2x.47dc18d.webp";